'use client';

import { useState, useEffect } from 'react';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import AppImage from '@/components/ui/AppImage';

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const pathname = usePathname();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const isActive = (path: string) => pathname === path;

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      scrolled ?
      'bg-white/95 backdrop-blur-md shadow-sm border-b border-border' :
      'bg-transparent'}`
      }>

      <nav className="max-w-[1400px] mx-auto px-6 md:px-12 py-2 md:py-3 flex items-center justify-between">
        {/* Logo */}
        <Link href="https://thestrategyshelf.com/" target="_blank" rel="noopener noreferrer" className="flex items-center group">
          <AppImage
            src="/assets/images/Logo_final_no_background-1771860991795.png"
            alt="The Strategy Shelf Logo"
            width={720}
            height={240}
            className="h-32 w-auto object-contain group-hover:scale-105 transition-transform"
          />
        </Link>

        {/* Navigation Links - Hidden on mobile for simplicity */}
        <div className="hidden md:flex items-center gap-4">
          <Link
            href="/homepage"
            className={`text-xs font-medium transition-colors ${
            isActive('/homepage') ?
            'text-foreground border-b-2 border-primary pb-1' : 'text-muted-foreground hover:text-foreground'}`
            }>

            Home
          </Link>
          <Link
            href="/homepage#chapters"
            className="text-xs font-medium text-muted-foreground hover:text-foreground transition-colors">Themes


          </Link>
          <Link
            href="/homepage#author"
            className="text-xs font-medium text-muted-foreground hover:text-foreground transition-colors">

            Author
          </Link>
        </div>
      </nav>
    </header>);

}